































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Form } from 'wok-forms';

@Component
export default class PasswordUpdate extends Vue {
    @Prop() signinRoute: any;
    @Prop() passwordRecoveryRoute: any;
    @Prop() bannerSrc: any;

    password1 = '';
    password2 = '';
    passwordMismatch = false;
    passwordUpdateError: boolean = false;
    submitEnabled = false;

    get isMobile() {
        return this.$store.state.isMobile;
    }

    onPasswordChange() {
        this.submitEnabled = !!this.password1 && this.password1 == this.password2;
    }

    async onSubmit() {
        let code = this.$route.query['c'];
        let userId = this.$route.query['u'];

        if (this.password1 == this.password2) {
            this.submitEnabled = false;
            let response = await this.$store.dispatch('passwordUpdate', { userId, code, password: this.password1 });
            if (response.result == "OK") {
                this.$store.commit('setUIMessage', 'password-updated');
                this.$router.replace(this.signinRoute);
            }
            else {
                this.passwordUpdateError = true;
            }
            this.submitEnabled = true;
        }
        else {
            this.passwordMismatch = true;
        }
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/dndg/access/password-update.vue